import { useState } from 'react';
import type { CrmStageProjection } from '../types/crmStage.types';
import { crmStagesKey, resolveHandoffCrmStages } from '../utils/crmStageDisplay';

type Stages = readonly CrmStageProjection[] | null | undefined;

interface Authority {
  detailKey: string | null;
  listKeyAtDetail: string;
  listSupersededDetail: boolean;
}

/** Handoff card stages: cached detail until the list refreshes, then the list. */
export function useHandoffCrmStages(listStages: Stages, detailStages: Stages) {
  const listKey = crmStagesKey(listStages);
  const detailKey = detailStages == null ? null : crmStagesKey(detailStages);
  const [stored, setStored] = useState<Authority>({
    detailKey,
    listKeyAtDetail: listKey,
    listSupersededDetail: false,
  });
  // Render-time update, React's pattern for state derived from previous props.
  // A new detail result resets authority; any later list change hands it to
  // the list for good (until the next detail result).
  let authority = stored;
  if (stored.detailKey !== detailKey) {
    authority = { detailKey, listKeyAtDetail: listKey, listSupersededDetail: false };
  } else if (!stored.listSupersededDetail && listKey !== stored.listKeyAtDetail) {
    authority = { ...stored, listSupersededDetail: true };
  }
  if (authority !== stored) setStored(authority);
  return resolveHandoffCrmStages(listStages, detailStages, authority.listSupersededDetail);
}
